import React, { useContext } from 'react'

import { CustomObjectTemplateStoreContext } from '../../contexts'
import { CustomObjectTemplateStore } from '../../types'

const useCustomObjectTemplateStore = (): CustomObjectTemplateStore => {
   const customObjectTemplateStore = useContext(
      CustomObjectTemplateStoreContext
   )

   if (!customObjectTemplateStore) {
      throw new Error(
         'Expected to be wrapped in CustomObject Template Store Provider'
      )
   }

   return customObjectTemplateStore
}

export { useCustomObjectTemplateStore }
